export default "__VITE_ASSET__JeWAwy$c__"